import { getScormTokenClient } from "../client/svcScorm";
import { getScormIdentity } from "./rxd";

export function isGuestAccessMode(): boolean {
  const pathSegments = window.location.pathname.split("/").filter(Boolean);
  return pathSegments[0] === "guest";
}

export function getGuestAccessKeys(): { accessKey: string; lessonKey: string } | null {
  const pathSegments = window.location.pathname.split("/").filter(Boolean);
  if (pathSegments[0] !== "guest") {
    return null;
  }
  const accessKey = pathSegments[1] || "";
  const lessonKey = pathSegments[2] || "";

  return { accessKey, lessonKey };
}

export async function fetchNewScormToken(): Promise<string> {
  const guestKeys = getGuestAccessKeys();
  if (!guestKeys) {
    throw new Error("Tried to fetch SCORM token but not in guest access mode");
  }

  // Get scormIdentity from rxd utils
  const scormIdentity = await getScormIdentity();
  const scormClient = getScormTokenClient();
  const result = await scormClient.getScormToken(
    guestKeys.accessKey,
    scormIdentity,
    guestKeys.lessonKey
  );
  if (result.error) {
    throw result.error;
  }
  return result.data.access_token;
}
